export const CLIENT_MUTATION_ID_HEADER = 'X-Client-Mutation-Id'

export const clientMutationIdRegistry = {
  ttlMs: 5 * 60 * 1000,
  localMutationIds: new Map<string, number>(),

  createFallbackMutationId(): string {
    return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`
  },

  pruneExpiredMutationIds() {
    const now = Date.now()
    for (const [mutationId, expiresAt] of this.localMutationIds.entries()) {
      if (expiresAt <= now) {
        this.localMutationIds.delete(mutationId)
      }
    }
  },

  registerMutationId(mutationId: string) {
    this.pruneExpiredMutationIds()
    this.localMutationIds.set(mutationId, Date.now() + this.ttlMs)
  },

  createAndRegisterClientMutationId() {
    const mutationId = this.createFallbackMutationId()
    this.registerMutationId(mutationId)
    return mutationId
  },

  registerClientMutationId(mutationId: string | null | undefined) {
    if (!mutationId) return
    this.registerMutationId(mutationId)
  },

  hasRegisteredClientMutationId(mutationId: string | null | undefined): boolean {
    if (!mutationId) return false
    this.pruneExpiredMutationIds()
    return this.localMutationIds.has(mutationId)
  }
}
